import Vue from 'vue'
import { fb, au } from '../plugins/firebase'
import { momento } from '../plugins/moment'
// import { limpiar } from '../mixins/limpiar'

export default {
  namespaced: true,
  state: {
    single: null,
    uno: null,
    dos: null,
    anual: [],
    meses: [
      {mes: 'Enero', id: '01'},
      {mes: 'Febrero', id: '02'},
      {mes: 'Marzo', id: '03'},
      {mes: 'Abril', id: '04'},
      {mes: 'Mayo', id: '05'},
      {mes: 'Junio', id: '06'},
      {mes: 'Julio', id: '07'},
      {mes: 'Agosto', id: '08'},
      {mes: 'Septiembre', id: '09'},
      {mes: 'Octubre', id: '10'},
      {mes: 'Noviembre', id: '11'},
      {mes: 'Diciembre', id: '12'}
    ],
    anios: [
      momento().format('YYYY'),
      momento().subtract(1, 'year').format('YYYY'),
    ],
  },
  mutations: {
    setMensual (state, p) {
      switch (p.tipo) {
        case 'single':
          state.single = p.resumen
          break;
        case 'uno':
          state.uno = p.resumen
          break;
        case 'dos':
          state.dos = p.resumen
          break;
        default:
          break;
      }
    },
    initAnual (state) {
      state.anual = []
    },
    setAnual (state, p) {
      state.anual.push(p)
    },
    calculando (state, p) {
      state.calculando = p
    }
  },
  actions: {
    getMes (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('reportes').doc(p.doc).get()
        .then(resumen => {
          ctx.commit('setMensual', {resumen: resumen.data(), tipo: p.tipo})
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    getAnio (ctx, p) {
      ctx.commit('initAnual')
      return new Promise ((resolve, reject) => {
        fb.collection('reportes').where('anio', '==', p.anio).get()
        .then(results => {
          results.forEach(doc => {
            ctx.commit('setAnual', doc.data())
          })
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    resumenear (ctx, p) {
      return new Promise((resolve, reject) => {
        au.currentUser.getIdToken(/* forceRefresh */ true)
        .then(token => {
          let url = p.fun
          return Vue.prototype.$axios.post(url, {user: token, mes: p.mes, anio: p.anio})
        })
        .then(() => {
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    }
  },
  getters: {
    single: (state) => state.single,
    uno: (state) => state.uno,
    dos: (state) => state.dos,
    anual: (state) => state.anual,
    meses: (state) => state.meses,
    anios: (state) => state.anios
  }
}